// extracted by mini-css-extract-plugin
export default {"GridContainer":"SpeakerLayout_GridContainer__asrgD","Speaker":"SpeakerLayout_Speaker__FJwPw"};